import React, { useEffect, useRef } from 'react';
var FilterTypeConfig = /** @class */ (function () {
    function FilterTypeConfig() {
    }
    return FilterTypeConfig;
}());
var CommentSidebarFilterConfig = /** @class */ (function () {
    function CommentSidebarFilterConfig() {
    }
    return CommentSidebarFilterConfig;
}());
;
var CommentSidebarGroupConfig = /** @class */ (function () {
    function CommentSidebarGroupConfig() {
    }
    return CommentSidebarGroupConfig;
}());
var CommentSidebarFilters = /** @class */ (function () {
    function CommentSidebarFilters() {
    }
    return CommentSidebarFilters;
}());
var SnippylyCommentsSidebar = function (props) {
    var embedMode = props.embedMode, floatingMode = props.floatingMode, enableUrlNavigation = props.enableUrlNavigation, urlNavigation = props.urlNavigation, queryParamsComments = props.queryParamsComments, pageMode = props.pageMode, currentLocationSuffix = props.currentLocationSuffix, sortData = props.sortData, filterConfig = props.filterConfig, groupConfig = props.groupConfig, filters = props.filters, excludeLocationIds = props.excludeLocationIds, variant = props.variant, pageModeComposerVariant = props.pageModeComposerVariant, dialogVariant = props.dialogVariant, shadowDom = props.shadowDom, searchPlaceholder = props.searchPlaceholder, openSidebar = props.openSidebar, onSidebarOpen = props.onSidebarOpen, onSidebarCommentClick = props.onSidebarCommentClick, onCommentClick = props.onCommentClick, onSidebarClose = props.onSidebarClose, darkMode = props.darkMode, position = props.position, filterPanelLayout = props.filterPanelLayout, customActions = props.customActions, focusedThreadDialogVariant = props.focusedThreadDialogVariant, focusedThreadMode = props.focusedThreadMode, onCommentNavigationButtonClick = props.onCommentNavigationButtonClick, filterOptionLayout = props.filterOptionLayout, filterCount = props.filterCount;
    var ref = useRef();
    var openSidebarRef = useRef(openSidebar);
    var onSidebarOpenRef = useRef(onSidebarOpen);
    var onSidebarCommentClickRef = useRef(onSidebarCommentClick);
    var onCommentClickRef = useRef(onCommentClick);
    var onSidebarCloseRef = useRef(onSidebarClose);
    var onCommentNavigationButtonClickRef = useRef(onCommentNavigationButtonClick);
    // Update the ref to always point to the latest callback function
    useEffect(function () {
        openSidebarRef.current = openSidebar;
    }, [openSidebar]);
    useEffect(function () {
        onSidebarOpenRef.current = onSidebarOpen;
    }, [onSidebarOpen]);
    useEffect(function () {
        onSidebarCommentClickRef.current = onSidebarCommentClick;
    }, [onSidebarCommentClick]);
    useEffect(function () {
        onSidebarCloseRef.current = onSidebarClose;
    }, [onSidebarClose]);
    useEffect(function () {
        onCommentClickRef.current = onCommentClick;
    }, [onCommentClick]);
    useEffect(function () {
        onCommentNavigationButtonClickRef.current = onCommentNavigationButtonClick;
    }, [onCommentNavigationButtonClick]);
    useEffect(function () {
        var element;
        var handleSidebarOpen = function (event) {
            if (openSidebarRef.current) {
                openSidebarRef.current(event === null || event === void 0 ? void 0 : event.detail);
            }
            if (onSidebarOpenRef.current) {
                onSidebarOpenRef.current(event === null || event === void 0 ? void 0 : event.detail);
            }
        };
        var handleSidebarCommentClick = function (event) {
            if (onSidebarCommentClickRef.current) {
                onSidebarCommentClickRef.current(event === null || event === void 0 ? void 0 : event.detail);
            }
            if (onCommentClickRef.current) {
                onCommentClickRef.current(event === null || event === void 0 ? void 0 : event.detail);
            }
        };
        var handleSidebarClose = function (event) {
            if (onSidebarCloseRef.current) {
                onSidebarCloseRef.current(event === null || event === void 0 ? void 0 : event.detail);
            }
        };
        var handleCommentNavigationButtonClick = function (event) {
            if (onCommentNavigationButtonClickRef.current) {
                onCommentNavigationButtonClickRef.current(event === null || event === void 0 ? void 0 : event.detail);
            }
        };
        if (ref.current) {
            element = ref.current;
            if (element) {
                element.addEventListener('onSidebarOpen', handleSidebarOpen);
                element.addEventListener('onSidebarCommentClick', handleSidebarCommentClick);
                element.addEventListener('onSidebarClose', handleSidebarClose);
                element.addEventListener('onCommentNavigationButtonClick', handleCommentNavigationButtonClick);
            }
        }
        return function () {
            if (element) {
                element.removeEventListener('onSidebarOpen', handleSidebarOpen);
                element.removeEventListener('onSidebarCommentClick', handleSidebarCommentClick);
                element.removeEventListener('onSidebarClose', handleSidebarClose);
                element.removeEventListener('onCommentNavigationButtonClick', handleCommentNavigationButtonClick);
            }
        };
    }, []);
    return (React.createElement("velt-comments-sidebar", { ref: ref, position: position, "filter-panel-layout": filterPanelLayout, "focused-thread-mode": [true, false].includes(focusedThreadMode) ? (focusedThreadMode ? 'true' : 'false') : undefined, "focused-thread-dialog-variant": focusedThreadDialogVariant, "custom-actions": [true, false].includes(customActions) ? (customActions ? 'true' : 'false') : undefined, "shadow-dom": [true, false].includes(shadowDom) ? (shadowDom ? 'true' : 'false') : undefined, "embed-mode": [true, false].includes(embedMode) ? (embedMode ? 'true' : 'false') : undefined, "enable-url-navigation": [true, false].includes(enableUrlNavigation) ? (enableUrlNavigation ? 'true' : 'false') : undefined, "url-navigation": [true, false].includes(urlNavigation) ? (urlNavigation ? 'true' : 'false') : undefined, "query-params-comments": [true, false].includes(queryParamsComments) ? (queryParamsComments ? 'true' : 'false') : undefined, "page-mode": [true, false].includes(pageMode) ? (pageMode ? 'true' : 'false') : undefined, "current-location-suffix": [true, false].includes(currentLocationSuffix) ? (currentLocationSuffix ? 'true' : 'false') : undefined, "filter-config": filterConfig ? JSON.stringify(filterConfig) : undefined, "group-config": groupConfig ? JSON.stringify(groupConfig) : undefined, filters: filters ? JSON.stringify(filters) : undefined, "exclude-location-ids": excludeLocationIds ? JSON.stringify(excludeLocationIds) : undefined, variant: variant, "page-mode-composer-variant": pageModeComposerVariant, "dialog-variant": dialogVariant, "sort-data": sortData, "search-placeholder": searchPlaceholder, "dark-mode": [true, false].includes(darkMode) ? (darkMode ? 'true' : 'false') : undefined, "floating-mode": [true, false].includes(embedMode) ? (embedMode ? 'true' : 'false') : undefined, "filter-option-layout": filterOptionLayout, "filter-count": [true, false].includes(filterCount) ? (filterCount ? 'true' : 'false') : undefined }));
};
export default SnippylyCommentsSidebar;
